
import { useFormContext, Controller } from 'react-hook-form';

import { TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers';

export enum TypeDateField {
    DATE = 'date',
    TIME = 'time',
}

type Props = TextFieldProps & {
    isZero?: boolean;
    name: string;
    type: TypeDateField;
    format?: string;
};

export default function RHFDateField({ name, helperText, type, sx, format }: Props) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) =>
                type === TypeDateField.DATE ? (
                    <DatePicker
                        {...field}
                        format={format}
                        slotProps={{
                            textField: {
                                sx,
                                helperText: error ? error?.message : helperText,
                                required: true,
                            },
                        }}
                    />
                ) : (
                    <TimePicker
                        {...field}
                        format={format}
                        slotProps={{
                            textField: {
                                sx,
                                helperText: error ? error?.message : helperText,
                                required: true,
                            },
                        }}
                    />
                )
            }
        />
    );
}
